import compose from 'recompose/compose';
import subPaymentWPay from 'app/containers/Subs/subPaymentWPay';


export default compose(
  subPaymentWPay
);
